import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { ChartContainer } from "../../view/ChartContainer";

export default function DashboardChartSkeleton({ title, subtitle, isPieChart = false }) {
    return (
        <ChartContainer noHeader={true} className="oct_chart-card-v2">
            <div className="oct_chart-header-v2">
                <p className="oct_chart-subtitle-v2">
                    {subtitle ? subtitle : <Skeleton variant="text" width={120} height={16} />}
                </p>
                <h3 className="oct_chart-title-v2">
                    {title ? title : <Skeleton variant="text" width={180} height={24} />}
                </h3>
            </div>
            
            <div className="oct_interactive-legend-wrapper-v2">
                <div className="oct_interactive-legend-v2">
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                </div>
            </div>

            <div className="oct_recharts-wrapper-v2 oct_chart-no-interaction d-flex align-items-center justify-content-center">
                {isPieChart ? (
                    <Skeleton variant="circular" width={200} height={200} />
                ) : (
                    <Skeleton variant="rectangular" width="100%" height="100%" className="oct_skeleton-radius-4" />
                )}
            </div>
        </ChartContainer>
    );
}
